import { ShieldCheck } from "lucide-react";

export default function Safety() {
  return (
    <section className="mx-auto max-w-6xl px-5 pt-12 pb-6 sm:px-8 sm:pt-16 sm:pb-8">
      <div className="flex flex-col items-center text-center gap-6 rounded-[32px] bg-[#F8FDF9] border-2 border-emerald-100/40 px-6 py-10  sm:flex-row sm:items-center sm:text-left sm:gap-8 sm:px-10 sm:py-8 lg:gap-10">
        <div className="flex h-28 w-28 shrink-0 items-center justify-center rounded-full bg-[#E8F8EE] shadow-sm sm:h-32 sm:w-32 mb-2 sm:mb-0">
          <ShieldCheck className="h-14 w-14 text-[#10B981]" strokeWidth={2.5} />
        </div>

        <div>
          <h3 className="font-display text-2xl sm:text-[28px] font-extrabold text-slate-900 leading-tight">
            Our Commitment <br className="block sm:hidden" /> to Safety
          </h3>
          <p className="mt-3 font-semibold text-slate-800 text-[15px] sm:text-base">
            Your safety is our priority.
          </p>

          <p className="mt-4 text-[14px] leading-relaxed text-slate-700 sm:text-base lg:text-[15px]">
            SoloConnect offers features designed to help you travel with
            greater confidence, including profile verification, Safe Mode,
            Trusted Contacts, user reporting, blocking, and an SOS feature.
          </p>
          <p className="mt-4 text-[14px] leading-relaxed text-slate-700 sm:text-base lg:text-[15px]">
            While these tools promote a safer community, we encourage every
            traveler to exercise good judgment, verify information
            independently, and follow safe travel practices when meeting
            new people.
          </p>
        </div>
      </div>
    </section>
  );
}
